import {
  ACCOUNT_INTEGRATIONS,
  ACCOUNT_SCHEDULE,
  ACCOUNT_SETTINGS,
  CLINIC_SETTINGS,
  CLINIC_SETTINGS_API_KEYS,
  CLINIC_SETTINGS_COOPERATION,
  CLINIC_SETTINGS_OFFICES,
  CLINIC_SETTINGS_PAYMENTS,
  CLINIC_SETTINGS_PLAN,
  CLINIC_SETTINGS_PLAN_INVOICES,
  CLINIC_SETTINGS_TEAM,
  COOPERATION_SETTINGS,
  DIETICIAN_SETTINGS,
  DIETICIAN_SETTINGS_EMPLOYEES,
  DIETICIAN_SETTINGS_GENERAL,
  DIETICIAN_SETTINGS_KEYS,
  DIETICIAN_SETTINGS_OFFICES,
  DIETICIAN_SETTINGS_ONLINE_PAYMENTS,
  DIETICIAN_SETTINGS_PRODUCTS,
  INTEGRATIONS,
  PLANS_AND_PAYMENTS,
  PLANS_AND_PAYMENTS_INVOICES,
  SALES_PRODUCTS,
  SETTINGS,
  SETTINGS_SCHEDULE,
} from "./routes";

export interface LegacySettingsRedirect {
  from: string;
  to: string;
}

export const LEGACY_SETTINGS_REDIRECTS: readonly LegacySettingsRedirect[] = [
  { from: SETTINGS, to: ACCOUNT_SETTINGS },
  { from: SETTINGS_SCHEDULE, to: ACCOUNT_SCHEDULE },
  { from: INTEGRATIONS, to: ACCOUNT_INTEGRATIONS },
  { from: DIETICIAN_SETTINGS, to: CLINIC_SETTINGS },
  { from: DIETICIAN_SETTINGS_GENERAL, to: CLINIC_SETTINGS },
  { from: DIETICIAN_SETTINGS_OFFICES, to: CLINIC_SETTINGS_OFFICES },
  { from: DIETICIAN_SETTINGS_EMPLOYEES, to: CLINIC_SETTINGS_TEAM },
  { from: DIETICIAN_SETTINGS_PRODUCTS, to: SALES_PRODUCTS },
  { from: DIETICIAN_SETTINGS_KEYS, to: CLINIC_SETTINGS_API_KEYS },
  { from: DIETICIAN_SETTINGS_ONLINE_PAYMENTS, to: CLINIC_SETTINGS_PAYMENTS },
  { from: PLANS_AND_PAYMENTS, to: CLINIC_SETTINGS_PLAN },
  { from: PLANS_AND_PAYMENTS_INVOICES, to: CLINIC_SETTINGS_PLAN_INVOICES },
  { from: COOPERATION_SETTINGS, to: CLINIC_SETTINGS_COOPERATION },
];

const trimTrailingSlash = (pathname: string) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

export const legacySettingsTarget = (pathname: string): string | undefined =>
  LEGACY_SETTINGS_REDIRECTS.find(
    ({ from }) => from === trimTrailingSlash(pathname),
  )?.to;
